import amber from '@material-ui/core/colors/amber';
import blue from '@material-ui/core/colors/blue';
import deepOrange from '@material-ui/core/colors/deepOrange';
import deepPurple from '@material-ui/core/colors/deepPurple';
import green from '@material-ui/core/colors/green';
import indigo from '@material-ui/core/colors/indigo';
import lightGreen from '@material-ui/core/colors/lightGreen';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';
import teal from '@material-ui/core/colors/teal';
const stringToColor = str => {
  const shade = 500;
  if (!str) {
    return deepPurple[shade];
  }
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let hex;
  for (let x = 0; x < 3; x++) {
    const value = hash >> x * 8 & 0xff;
    hex = ('00' + value.toString(16)).substr(-2);
  }
  const random = parseInt(hex, 16) % 10;
  const colors = [blue[shade], red[shade], deepOrange[shade], deepPurple[shade], indigo[shade], green[shade], lightGreen[shade], orange[shade], teal[shade], amber[shade]];
  return colors[random];
};
export { stringToColor };